import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Dimmer, Loader } from "semantic-ui-react";
import LoadingAction from "@common/redux/actions/LoadingAction";

const LoadingModal = (props) => {
  useEffect(() => {
    if (props.data.loading) {
      // Scroll to top
      window.scrollTo(0, 0);
      // Disable scrolling
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable scrolling
      document.body.style.overflow = "unset";
    }

    // Cleanup function to ensure scrolling is restored if component unmounts
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [props.data.loading]);

  return (
    <Dimmer
      active={props.data.loading}
      style={{
        zIndex: "9000000000000000",
        minheight: "100vh",
        height: "100%",
      }}
    >
      <Loader inline size="large">
        Loading...
      </Loader>
    </Dimmer>
  );
};

const mapStateToProps = (state) => {
  return {
    data: LoadingAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(LoadingModal);
